<template>
  <div class="body onboarding-body">
    <div class="rounded-ocean-blue-overlay" />
    <div class="top-line">
      Welcome to <br />
      <span class="bold-text">Adapt Prospector</span>
      <v-button
        :className="'but-wiggle'"
        :callback="openOnboardingLink"
        :type="'button'"
        :text="'Let\'s Start'"
        :showIcon="true"
      />
    </div>
    <div class="content">
      <div class="img">
        <img src="./../../assets/icons/gif/prospectorOnboarding.gif" />
      </div>
    </div>
  </div>
</template>

<script>
import button from './../Button.vue'
const ONBOARDING_COMPLETED = 'onboardingCompleted'
import {
  ONBOARDING_SHOWN,
  ONBOARDING_CLICKED
} from '@/assets/util/constants/analytics.js'
import sharedFunctions from '@/assets/util/functions.js'
export default {
  name: 'OnboardingView',
  components: {
    'v-button': button
  },
  data: function() {
    return {
      // showOnboardingTour: false
    }
  },
  methods: {
    openOnboardingLink() {
      sharedFunctions.track(ONBOARDING_CLICKED, null, this.$store.state)
      sharedFunctions.passMsgToContentScript({ type: 'ONBOARDING_CLICKED' })
      localStorage.setItem(ONBOARDING_COMPLETED, true)
      window.open(
        'https://www.linkedin.com/in/pradeep-muruganandam-562906171/',
        '_blank'
      )
    }
  },
  created() {
    const that = this
    setTimeout(function() {
      sharedFunctions.track(ONBOARDING_SHOWN, null, that.$store.state)
    }, 2000)
    // setTimeout(() => (this.showOnboardingTour = true), 4000)
  }
}
</script>

<style scoped lang="scss">
.body {
  position: relative;
  // top: 51px;
  padding: 0px;
  z-index: 0;
  background-color: #f8ecec;
  padding-bottom: 30px;
  .content {
    margin: 5px 15px;
    position: relative;
    .img {
      margin-bottom: 10px;
      text-align: center;
      img {
        border-radius: 20px;
        width: 100%;
      }
    }
  }
  .rounded-ocean-blue-overlay {
    width: 150px;
    height: 150px;
    background-color: #d4faec;
    border-radius: 50%;
    position: absolute;
    z-index: -1;
    top: 20px;
    right: 0px;
  }
  .top-line {
    padding: 20px 0 10px 15px;
    font-size: 22px;
    line-height: 28px;
    color: #222020;
    letter-spacing: 0.4px;
    font-family: 'Figtree-Regular';
    .bold-text {
      font-weight: bold;
      font-size: 24px;
    }
  }
  .max-height {
    height: -webkit-fill-available;
  }

  .big-fnt {
    font-size: 25px;
    color: #787878;
    margin: 15px 0;
    display: block;
    line-height: 32px;
  }
  .onboarding-overlay {
    background: rgba(0, 0, 0, 0.68);
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: calc(100vh - 51px);
    z-index: 111;
    transition: all 0.3s ease;
  }
}
.onboarding-body {
  min-height: calc(100vh - 51px);
}
.body::v-deep .but {
  width: fit-content;
  font-size: 14px;
  position: relative;
  z-index: 112;
  background-color: #3952fa;
  margin-top: 12px;
  display: flex;
  align-items: center;
  padding: 10px 15px 8px;
  font-family: 'Figtree-Medium';
  border-radius: 20px;

  svg {
    margin-top: 2px;
    margin-left: 10px;
  }
  &.but-wiggle {
    animation: tidleShake 5s linear infinite running;
    -webkit-animation: tidleShake 5s linear infinite running;
  }
}
</style>
